<template>
    <div class="about">
        <div class="abou_right">
            <div class="title">{{registList.name}}</div>
            <div class="message" v-html="registList.content">

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                registList: []
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                let _this = this;
                let param = new FormData();
                param.append('type', 1);
                _this.api.registText(param).then(res => {
                    console.log(res);
                    _this.registList = res.data;
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .about {
        width: @a;
        height: auto;
        margin-left: 4%;

        .abou_right {
            width: @a;
            height: auto;

            .title {
                width: @a;
                height: 24px;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .message {
                width: @a;
                height: auto;
                font-family: MicrosoftYaHei;
                font-size: 18px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 36px;
                letter-spacing: 2px;
                color: #333333;
                margin-top: 35px;
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/vip/aboutUs.vue